import { render, staticRenderFns } from "./BoostModal.vue?vue&type=template&id=bc621980&scoped=true&"
import script from "./BoostModal.vue?vue&type=script&lang=js&"
export * from "./BoostModal.vue?vue&type=script&lang=js&"
import style0 from "./BoostModal.vue?vue&type=style&index=0&id=bc621980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc621980",
  null
  
)

export default component.exports